import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExternalLinkService } from '../services';
import { AuthenticationService } from 'src/shared/auth';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        private readonly authenticationService: AuthenticationService,
        private readonly externalLinkService: ExternalLinkService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const newRequest = req.clone({
            setHeaders: {
                'token': this.authenticationService.token,
                'external-link': this.externalLinkService.ExternalLink
            }
        });

        return next.handle(newRequest);
    }
}
